
import React, { useState } from 'react';
import { XMarkIcon } from './icons';

interface DisclaimerPageProps {
  onClose: () => void;
}

const DisclaimerPage: React.FC<DisclaimerPageProps> = ({ onClose }) => {
  const [showScrollIndicator, setShowScrollIndicator] = useState(true);
  return (
    <div 
      className="fixed inset-0 bg-gray-900/80 backdrop-blur-sm z-[101] flex items-center justify-center p-4 animate-fade-in"
      onClick={onClose}
    >
      <div 
        className="bg-gray-800 border border-red-700 rounded-lg shadow-2xl max-w-2xl w-full flex flex-col animate-modal-panel-fade-in-down light-theme:bg-white light-theme:border-gray-300"
        onClick={e => e.stopPropagation()}
      >
        <header className="flex items-center justify-between p-4 border-b border-gray-700 light-theme:border-gray-300">
          <h2 className="text-2xl font-bold text-red-400">Beta Software Disclaimer</h2>
          <button onClick={onClose} className="p-2 rounded-full hover:bg-gray-700 light-theme:hover:bg-gray-200" aria-label="Close Disclaimer">
            <XMarkIcon className="w-6 h-6 text-gray-400" />
          </button>
        </header>
        <main className="p-6 text-gray-300 space-y-4 max-h-[70vh] overflow-y-auto scrollbar-hide light-theme:text-gray-700 relative" onScroll={() => setShowScrollIndicator(false)}>
          <p className="font-semibold text-lg text-gray-100 light-theme:text-gray-800">Please read this disclaimer carefully before using LandSurv.ai.</p>
          <p>This software is provided "as is" as a beta version, without warranty of any kind, express or implied, including but not limited to the warranties of merchantability, fitness for a particular purpose, and non-infringement. In no event shall the authors or copyright holders be liable for any claim, damages, or other liability, whether in an action of contract, tort, or otherwise, arising from, out of, or in connection with the software or the use or other dealings in the software.</p>
          <p className="font-bold text-yellow-400">This tool is intended for educational, research, and preliminary analysis purposes only. It is NOT a substitute for professional engineering or land surveying judgment.</p>
          <ul className="list-disc list-inside space-y-2 pl-2 text-gray-400">
            <li>All calculations, interpretations, and visualizations generated by the AI MUST be independently verified by a qualified professional before being used for any design, construction, or legal purposes.</li>
            <li>The user assumes full responsibility for the accuracy and reliability of any data produced by this application.</li>
            <li>Do not use this software for any safety-critical or real-world navigation tasks without independent verification from certified equipment and professional oversight.</li>
          </ul>
          <p>By using this software, you acknowledge that you have read and understood this disclaimer and agree to its terms.</p>
          
          {/* Scroll Indicator */}
          {showScrollIndicator && (
            <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 z-20 animate-bounce opacity-60 pointer-events-none">
              <svg className="w-16 h-16 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M19 9l-7 7-7-7" />
              </svg>
            </div>
          )}
        </main>
      </div>
    </div>
  );
};

export default DisclaimerPage;
